export const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const tailItemLayout = {
  wrapperCol: { span: 17, offset: 7 },
};

